module.exports = __webpack_public_path__ + "static/media/img-starter-kit.b2c14938.svg";